import _ from 'lodash';

import Entity from './Entity';


const alertConfigurationEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'AlertTypeEnum' }
};


export default class AlertConfiguration {
  constructor(type = null) {
    this.fields.type.value = type;
  }


  fields = {
    type: {
      value: null
    },
    emails: {
      value: []
    }
  };


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      alertConfigurationEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  static createFromQueryValues(values) {
    const alertConfiguration = new this();

    for (let field in alertConfiguration.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'emails':
            if (Array.isArray(values[field])) {
              for (let email of values[field]) {
                alertConfiguration.fields[field].value.push(email);
              }
            }
            break;
          default:
            alertConfiguration.fields[field].value = values[field];
        }
      }
    }

    return alertConfiguration;
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(AlertInput);

    for (let field in values) {
      switch (field) {
        case 'emails':
          values[field] = [];
          for (let email of this.fields[field].value) {
            if (email) {
              values[field].push(email);
            }
          }
          break;
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }
}


export const AlertInput = {
  type: null,
  emails: null
}
